import { HttpOptions } from '@fe/g-utils';

export default function fetch(
  url: string,
  options?: HttpOptions,
): Promise<any> {
  return window.fetch(url, options);
}
